import React, { Component } from "react";
import {
    Box,
    Flex,
    Menu,
    Spacer,
    MenuButton,
    MenuItem,
    MenuList,
    Button,
    Image,
    Text
} from '@chakra-ui/react';

import "../assets/css/navbar.css";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

import ConfigService from "../services/ConfigService";


export default class Navbar extends Component {
    constructor(props) {
        super(props);
        this.configService = new ConfigService();
        this.state = {
            isDrawerOpen: false,
            customerLogoImgSrc: ""
        }
        this.toggleDrawer = this.toggleDrawer.bind(this)
    }

    componentDidMount()
    {
        let customerLogoImgSrc = this.configService.getCustomerLogoImagePath(this.props.userSession.gcid);
        this.setState({
          customerLogoImgSrc: customerLogoImgSrc
        });  
    }

    toggleDrawer() {
        this.setState({
            isDrawerOpen: !this.state.isDrawerOpen
        })
    }

    render() {
        return (
            <div className={(this.props.isVisible) ? "navbar": "navbar-hidden"}>
                <Flex >
                    <Box p='3'>Glasschain Data Integration Dashboard</Box>
                    <Spacer></Spacer>
                    <Box p='3'>
                    <Image
                        src={this.state.customerLogoImgSrc}
                        alt="Customer Logo"
                        w="35%"
                    />
                    </Box>
                    <Spacer></Spacer>
                    <Box p='2'>
                        <Flex direction='column'>
                            <Text>{this.props.userSession.uid}</Text>
                            <Text>{this.props.userSession.gcid}</Text>
                        </Flex>
                    </Box>
                    <Spacer></Spacer>
                    <Box p='3'>
                        {/* <Button variant='outline' onClick={this.toggleDrawer}>Filter Options</Button>
                         */}
                        <Menu>
                            <MenuButton as={Button} colorScheme="blue">
                            <FontAwesomeIcon icon={faBars} color="white"/>
                            </MenuButton>
                            <MenuList>
                                <MenuItem color="black" onClick={(e) => this.props.onLogoutRequest()}>Log Out</MenuItem>  
                                <MenuItem color="black" onClick={(e) => this.props.onUserGuideRequest()}>User Guide</MenuItem>
                                <MenuItem color="black" onClick={(e) => this.props.onAboutOpen(e)}>About</MenuItem>                
                            </MenuList>
                        </Menu>
                    </Box>
                </Flex>
            </div>
        )
    }
}